import {
	AavoMosaicNode,
	AavoMosaicPanel,
	AavoMosaicTab,
	AavoMosaicTabWithKey,
} from "src/components/common/mosaic/types.ts";
import { MosaicNode } from "react-mosaic-component";

export interface AavoMosaicNodeMappingResult {
	rootNode: MosaicNode<string>;
	allTabs: AavoMosaicTabWithKey[];
}

export const mapAavoMosaicNodes = (node: AavoMosaicNode): AavoMosaicNodeMappingResult =>
	mapNodesHelper(node, "root");

const mapNodesHelper = (node: AavoMosaicNode, key: string): AavoMosaicNodeMappingResult => {
	if (isMosaicPanel(node)) {
		return mapNodesHelper(
			{
				type: "tab",
				items: [node],
			},
			key,
		);
	} else if (isMosaicTab(node)) {
		return {
			rootNode: key,
			allTabs: [
				{
					...filterHiddenTabItems(node),
					key: key,
				},
			],
		};
	} else {
		const firstResult = mapNodesHelper(node.first, `${key}_first`);
		const secondResult = mapNodesHelper(node.second, `${key}_second`);
		return {
			rootNode: {
				direction: node.type,
				first: firstResult.rootNode,
				second: secondResult.rootNode,
				splitPercentage: node.splitPercentage,
			},
			allTabs: [...firstResult.allTabs, ...secondResult.allTabs],
		};
	}
};

const filterHiddenTabItems = (tab: AavoMosaicTab): AavoMosaicTab => {
	return {
		...tab,
		items: tab.items.filter((item) => !item.hidden),
	};
}

const isMosaicTab = (node: AavoMosaicNode): node is AavoMosaicTab => {
	return (node as AavoMosaicTab).type === "tab";
};

const isMosaicPanel = (node: AavoMosaicNode): node is AavoMosaicPanel => {
	return (node as AavoMosaicPanel).type === "panel";
};
